/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import JobItemStatus from "./helpers/JobItemStatus";

const JobLoadedItem = ({ job, loadedItem }) => (
  <tr className="content">
    <td>{job.seq}</td>
    <td>{loadedItem.item.description}</td>
    <td>{loadedItem.item.quantity}</td>
    <td>
      <JobItemStatus job={job} jobItem={loadedItem} />
    </td>
  </tr>
);
JobLoadedItem.propTypes = {
  job: PropTypes.object.isRequired,
  loadedItem: PropTypes.object.isRequired
};

export default JobLoadedItem;



// WEBPACK FOOTER //
// ./src/components/jobs/JobLoadedItem.js